import _styled from "styled-components";
import React, { useCallback } from "react";
import { ReactComponent as PauseIcon } from "@svgr/webpack?-svgo,+titleProp,+ref!@smartheat/common/svg/pause2.svg";
import CompressorIconAsset from "@smartheat/common/png/compressor@112x112.png";
import { formatTemperature } from "../../../utils/formatTemperature";
import { ScheduleIndicator } from "../../ScheduleCircle/ScheduleIndicator";
import { useDeviceData } from "../../DeviceData/useDeviceData";
import { useRegistersSubscription } from "../../DeviceData/useRegistersSubscription";
import { useRegisterConfigQuery } from "../../DeviceData/useRegisterConfigQuery";
import { TemperatureMode } from "../TemperatureMode/TemperatureMode";
import { ToggleGroup } from "../ToggleGroup/ToggleGroup";
import { useAlarms } from "../../DeviceData/useAlarms";
import { ManualControl } from "../TemperatureMode/ManualControl";
import { useDeviceApi } from "../../DeviceData/useDeviceApi";

var OneCenterElement = _styled.div.withConfig({
  displayName: "Hw1Page__OneCenterElement",
  componentId: "sc-1af8nk7-0"
})(["position:relative;display:flex;justify-content:center;margin:64px auto 40px;width:368px;height:368px;@media screen and (max-width:419px){width:288px;height:288px;margin:40px auto 32px;}"]);

var OneCenterElement2 = _styled.div.withConfig({
  displayName: "Hw1Page__OneCenterElement2",
  componentId: "sc-1af8nk7-1"
})(["position:relative;display:flex;justify-content:center;flex:1;"]);

var IconContainer = _styled.div.withConfig({
  displayName: "Hw1Page__IconContainer",
  componentId: "sc-1af8nk7-2"
})(["width:100%;height:100%;display:flex;align-items:center;justify-content:center;"]);

var ScheduleIndicatorContainer = _styled.div.withConfig({
  displayName: "Hw1Page__ScheduleIndicatorContainer",
  componentId: "sc-1af8nk7-3"
})([""]);

var CircleElement = _styled.div.withConfig({
  displayName: "Hw1Page__CircleElement",
  componentId: "sc-1af8nk7-4"
})(["position:absolute;height:320px;width:320px;top:50%;left:50%;transform:translate(-50%,-50%);background-color:", ";border-radius:50%;display:flex;justify-content:center;opacity:", ";@media screen and (max-width:419px){height:240px;width:240px;}"], function (props) {
  return props.hasError ? "#dd4e4e" : "#4d9adf";
}, function (props) {
  return props.disabled ? 0.3 : 1;
});

var CircleContent = _styled.div.withConfig({
  displayName: "Hw1Page__CircleContent",
  componentId: "sc-1af8nk7-5"
})(["color:white;width:230px;"]);

var CenteredMessage = _styled.div.withConfig({
  displayName: "Hw1Page__CenteredMessage",
  componentId: "sc-1af8nk7-6"
})(["font-size:36px;text-align:center;display:flex;height:100%;align-items:center;justify-content:center;@media screen and (max-width:419px){font-size:30px;}"]);

var TemperatureLeftRight = _styled.div.withConfig({
  displayName: "Hw1Page__TemperatureLeftRight",
  componentId: "sc-1af8nk7-7"
})(["display:flex;font-size:28px;width:230px;margin:50px auto 0 auto;div{flex:1 1 50%;text-align:center;}@media screen and (max-width:419px){font-size:22px;width:180px;margin-top:48px;}"]);

var TemperatureCenter = _styled.div.withConfig({
  displayName: "Hw1Page__TemperatureCenter",
  componentId: "sc-1af8nk7-8"
})(["display:flex;justify-content:center;margin-top:38px;font-size:46px;@media screen and (max-width:419px){font-size:40px;margin-top:20px;}"]);

var TopLabel = _styled.div.withConfig({
  displayName: "Hw1Page__TopLabel",
  componentId: "sc-1af8nk7-9"
})(["position:absolute;font-size:20px;bottom:100%;left:50%;transform:translateX(-50%);"]);

var BottomLabel = _styled.div.withConfig({
  displayName: "Hw1Page__BottomLabel",
  componentId: "sc-1af8nk7-10"
})(["position:absolute;font-size:20px;top:100%;left:50%;transform:translateX(-50%);"]);

var LeftLabel = _styled.div.withConfig({
  displayName: "Hw1Page__LeftLabel",
  componentId: "sc-1af8nk7-11"
})(["position:absolute;font-size:20px;right:100%;top:50%;transform:translateY(-50%);"]);

var RightLabel = _styled.div.withConfig({
  displayName: "Hw1Page__RightLabel",
  componentId: "sc-1af8nk7-12"
})(["position:absolute;font-size:20px;left:100%;top:50%;transform:translateY(-50%);"]);

var ErrorContent = _styled.div.withConfig({
  displayName: "Hw1Page__ErrorContent",
  componentId: "sc-1af8nk7-13"
})(["font-size:20px;color:white;width:270px;display:flex;flex-direction:column;align-items:center;justify-content:space-between;"]);

var ErrorMessage = _styled.div.withConfig({
  displayName: "Hw1Page__ErrorMessage",
  componentId: "sc-1af8nk7-14"
})(["font-size:36px;margin-top:65px;text-align:center;@media screen and (max-width:419px){font-size:30px;margin-top:45px;}"]);

var BlockErrorMessage = _styled.div.withConfig({
  displayName: "Hw1Page__BlockErrorMessage",
  componentId: "sc-1af8nk7-15"
})(["font-size:30px;margin-top:65px;text-align:center;@media screen and (max-width:419px){font-size:24px;margin-top:45px;}"]);

var ErrorInfo = _styled.div.withConfig({
  displayName: "Hw1Page__ErrorInfo",
  componentId: "sc-1af8nk7-16"
})(["margin-bottom:48px;@media screen and (max-width:419px){margin-bottom:32px;}"]);

var NumberRow = _styled.div.withConfig({
  displayName: "Hw1Page__NumberRow",
  componentId: "sc-1af8nk7-17"
})(["font-size:24px;text-align:center;"]);

var TextRow = _styled.div.withConfig({
  displayName: "Hw1Page__TextRow",
  componentId: "sc-1af8nk7-18"
})(["font-size:22px;text-align:center;@media screen and (max-width:419px){font-size:18px;padding:0 24px;}"]);

var CompressorIndicatorImage = _styled.img.withConfig({
  displayName: "Hw1Page__CompressorIndicatorImage",
  componentId: "sc-1af8nk7-19"
})(["position:absolute;left:50%;transform:translateX(-50%);top:10px;width:28px;height:28px;"]);

var CompressorIndicator = function CompressorIndicator() {
  return /*#__PURE__*/React.createElement(CompressorIndicatorImage, {
    src: CompressorIconAsset,
    alt: ""
  });
};

function temperatureFromRegister(regValue) {
  return regValue ? Math.round(regValue / 10) : regValue;
}

var allRegisters = ["motohoursBlockState", "workingMode", "compressorStatus"];
export function Hw1Page() {
  var _useRegistersSubscrip = useRegistersSubscription(allRegisters),
      registersData = _useRegistersSubscrip.registersData;

  var registersConfig = useRegisterConfigQuery(allRegisters);
  var motohoursBlockState = registersData.motohoursBlockState,
      workingMode = registersData.workingMode,
      compressorStatus = registersData.compressorStatus;
  var alarms = useAlarms();

  if (workingMode === undefined || !registersConfig) {
    return /*#__PURE__*/React.createElement(OneCenterElement, null, /*#__PURE__*/React.createElement(CircleElement, null, /*#__PURE__*/React.createElement(CircleContent, null, /*#__PURE__*/React.createElement(CenteredMessage, null, "\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430..."))));
  }

  if (!registersConfig.workingMode.values || !registersConfig.compressorStatus.values) {
    return /*#__PURE__*/React.createElement(OneCenterElement, null, /*#__PURE__*/React.createElement(CircleElement, {
      hasError: true
    }, /*#__PURE__*/React.createElement(ErrorContent, null, /*#__PURE__*/React.createElement(BlockErrorMessage, null, "\u041E\u0448\u0438\u0431\u043A\u0430: \u0411\u0420"), /*#__PURE__*/React.createElement(ErrorInfo, null, /*#__PURE__*/React.createElement(NumberRow, null, "+7(499)704-13-98"), /*#__PURE__*/React.createElement(TextRow, null, "обратитесь в сервисный центр")))));
  }

  var isFirstRun = workingMode === registersConfig.workingMode.values.FIRSTRUN;
  var isUserMode = workingMode === registersConfig.workingMode.values.USER;
  var isClimateMode = workingMode === registersConfig.workingMode.values.CLIMATE;
  var unexpectedMode = workingMode !== undefined && !isUserMode && !isClimateMode;
  var isCompressorActive = compressorStatus === registersConfig.compressorStatus.values.ACTIVE;

  if (alarms.length > 0) {
    return /*#__PURE__*/React.createElement(OneCenterElement, null, /*#__PURE__*/React.createElement(CircleElement, {
      hasError: true
    }, /*#__PURE__*/React.createElement(ErrorContent, null, /*#__PURE__*/React.createElement(ErrorMessage, null, "\u041E\u0448\u0438\u0431\u043A\u0430: ", alarms[0]), /*#__PURE__*/React.createElement(ErrorInfo, null, /*#__PURE__*/React.createElement(NumberRow, null, "+7(499)704-13-98"), /*#__PURE__*/React.createElement(TextRow, null, "обратитесь в сервисный центр")))));
  }

  if (isFirstRun) {
    return /*#__PURE__*/React.createElement(OneCenterElement, null, /*#__PURE__*/React.createElement(CircleElement, null, /*#__PURE__*/React.createElement(ErrorContent, null, /*#__PURE__*/React.createElement(BlockErrorMessage, null, "\u041F\u0435\u0440\u0432\u044B\u0439 \u0437\u0430\u043F\u0443\u0441\u043A"), /*#__PURE__*/React.createElement(ErrorInfo, null, /*#__PURE__*/React.createElement(TextRow, null, "\u0418\u0434\u0451\u0442 \u043F\u0440\u043E\u0446\u0435\u0434\u0443\u0440\u0430 \u043F\u0435\u0440\u0432\u043E\u0433\u043E \u0437\u0430\u043F\u0443\u0441\u043A\u0430 \u0422\u041D, \u0431\u043B\u0438\u0436\u0430\u0439\u0448\u0438\u0435 72 \u0447\u0430\u0441\u0430 \u0444\u0443\u043D\u043A\u0446\u0438\u0438 \u0442\u0435\u043F\u043B\u043E\u0432\u043E\u0433\u043E \u043D\u0430\u0441\u043E\u0441\u0430 \u0431\u0443\u0434\u0443\u0442 \u043E\u0433\u0440\u0430\u043D\u0438\u0447\u0435\u043D\u044B"))), isCompressorActive && /*#__PURE__*/React.createElement(CompressorIndicator, null)));
  }

  if (motohoursBlockState) {
    return /*#__PURE__*/React.createElement(OneCenterElement, null, /*#__PURE__*/React.createElement(CircleElement, {
      hasError: true
    }, /*#__PURE__*/React.createElement(ErrorContent, null, /*#__PURE__*/React.createElement(BlockErrorMessage, null, "\u0422\u0435\u043F\u043B\u043E\u0432\u043E\u0439 \u043D\u0430\u0441\u043E\u0441 \u0437\u0430\u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u0430\u043D"), /*#__PURE__*/React.createElement(ErrorInfo, null, /*#__PURE__*/React.createElement(NumberRow, null, "+7(499)704-13-98"), /*#__PURE__*/React.createElement(TextRow, null, "обратитесь в сервисный центр")))));
  }

  if (unexpectedMode) {
    return /*#__PURE__*/React.createElement(OneCenterElement, null, /*#__PURE__*/React.createElement(CircleElement, {
      hasError: true
    }, /*#__PURE__*/React.createElement(ErrorContent, null, /*#__PURE__*/React.createElement(BlockErrorMessage, null, "\u041E\u0448\u0438\u0431\u043A\u0430: \u0420"), /*#__PURE__*/React.createElement(ErrorInfo, null, /*#__PURE__*/React.createElement(NumberRow, null, "+7(499)704-13-98"), /*#__PURE__*/React.createElement(TextRow, null, "обратитесь в сервисный центр")))));
  }

  if (isUserMode) {
    return /*#__PURE__*/React.createElement(UserModeContent, {
      isCompressorActive: isCompressorActive
    });
  }

  return /*#__PURE__*/React.createElement(ClimateModeContent, {
    isCompressorActive: isCompressorActive
  });
}

function UserModeContent(_ref) {
  var isCompressorActive = _ref.isCompressorActive;

  var _useRegistersSubscrip2 = useRegistersSubscription(["t3Sensor", "t4Sensor"]),
      _useRegistersSubscrip3 = _useRegistersSubscrip2.registersData,
      t3Sensor = _useRegistersSubscrip3.t3Sensor,
      t4Sensor = _useRegistersSubscrip3.t4Sensor;

  var _useDeviceData = useDeviceData(),
      heatConfig = _useDeviceData.heatConfig;

  var _useDeviceApi = useDeviceApi(),
      setModeTemperatures = _useDeviceApi.setModeTemperatures;

  var returnTemperature = heatConfig.tx["return"];
  var handleDecrement = useCallback(function () {
    setModeTemperatures({
      variables: {
        input: {
          "return": returnTemperature - 1
        }
      }
    });
  }, [setModeTemperatures, returnTemperature]);
  var handleIncrement = useCallback(function () {
    setModeTemperatures({
      variables: {
        input: {
          "return": returnTemperature + 1
        }
      }
    });
  }, [setModeTemperatures, returnTemperature]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(OneCenterElement, null, /*#__PURE__*/React.createElement(CircleElement, null, /*#__PURE__*/React.createElement(CircleContent, null, /*#__PURE__*/React.createElement(TemperatureLeftRight, null, /*#__PURE__*/React.createElement("div", null, formatTemperature(temperatureFromRegister(t3Sensor))), /*#__PURE__*/React.createElement("div", null, formatTemperature(temperatureFromRegister(t4Sensor)))), /*#__PURE__*/React.createElement(TemperatureCenter, null, formatTemperature(returnTemperature)), /*#__PURE__*/React.createElement(ManualControl, {
    incrementable: returnTemperature < 40,
    decrementable: returnTemperature > 6,
    onIncrement: handleIncrement,
    onDecrement: handleDecrement
  })), isCompressorActive && /*#__PURE__*/React.createElement(CompressorIndicator, null))));
}

function ClimateModeContent(_ref2) {
  var isCompressorActive = _ref2.isCompressorActive;

  var _useDeviceData2 = useDeviceData(),
      heatConfig = _useDeviceData2.heatConfig,
      heatMode = _useDeviceData2.heatMode,
      thermostatValue = _useDeviceData2.thermostatValue,
      pumpTime = _useDeviceData2.pumpTime;

  var _useRegistersSubscrip4 = useRegistersSubscription(["t8Sensor", "t9Sensor"]),
      _useRegistersSubscrip5 = _useRegistersSubscrip4.registersData,
      t8Sensor = _useRegistersSubscrip5.t8Sensor,
      t9Sensor = _useRegistersSubscrip5.t9Sensor;

  var _useDeviceApi2 = useDeviceApi(),
      setModeTemperatures = _useDeviceApi2.setModeTemperatures;

  var handleManualIncrement = useCallback(function () {
    setModeTemperatures({
      variables: {
        input: {
          manual: thermostatValue + 1
        }
      }
    });
  }, [thermostatValue, setModeTemperatures]);
  var handleManualDecrement = useCallback(function () {
    setModeTemperatures({
      variables: {
        input: {
          manual: thermostatValue - 1
        }
      }
    });
  }, [thermostatValue, setModeTemperatures]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(OneCenterElement, null, /*#__PURE__*/React.createElement(RightLabel, null, "6"), /*#__PURE__*/React.createElement(BottomLabel, null, "12"), /*#__PURE__*/React.createElement(LeftLabel, null, "18"), /*#__PURE__*/React.createElement(TopLabel, null, "24"), /*#__PURE__*/React.createElement(ScheduleIndicatorContainer, null, /*#__PURE__*/React.createElement(ScheduleIndicator, {
    heatConfig: heatConfig,
    heatMode: heatMode,
    error: false,
    pumpTime: pumpTime
  })), /*#__PURE__*/React.createElement(CircleElement, {
    disabled: heatMode === "VACATION" || heatConfig.forced === "AWAY"
  }, heatConfig.forced === "AWAY" ? /*#__PURE__*/React.createElement(IconContainer, null, /*#__PURE__*/React.createElement(PauseIcon, {
    width: 160,
    height: 160,
    fill: "#fff"
  })) : /*#__PURE__*/React.createElement(CircleContent, null, /*#__PURE__*/React.createElement(TemperatureLeftRight, null, /*#__PURE__*/React.createElement("div", null, formatTemperature(temperatureFromRegister(t8Sensor))), /*#__PURE__*/React.createElement("div", null, formatTemperature(temperatureFromRegister(t9Sensor)))), /*#__PURE__*/React.createElement(TemperatureCenter, null, formatTemperature(thermostatValue)), heatMode === "MANUAL" ? /*#__PURE__*/React.createElement(ManualControl, {
    incrementable: thermostatValue < 55,
    decrementable: thermostatValue > 6,
    onIncrement: handleManualIncrement,
    onDecrement: handleManualDecrement
  }) : /*#__PURE__*/React.createElement(TemperatureMode, {
    heatMode: heatMode
  })), isCompressorActive && /*#__PURE__*/React.createElement(CompressorIndicator, null))), /*#__PURE__*/React.createElement(OneCenterElement2, null, /*#__PURE__*/React.createElement(ToggleGroup, {
    heatConfig: heatConfig,
    heatMode: heatMode
  })));
}